// import React, { useEffect, useState } from "react";
// import { IoDocumentText } from "react-icons/io5";
// import { MdEditDocument } from "react-icons/md";
// export function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen }) {

//     const [open, setOpen] = useState(false);

//     const hasActiveChild = kids.some(
//         (k) => k.target?.toLowerCase() === activeMenu
//     );

//     useEffect(() => {
//         if (hasActiveChild) setOpen(true);
//     }, [hasActiveChild]);

//     return (
//         <li className="parent-menu">

//             <div
//                 className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
//                 role="button"
//                 tabIndex={0}
//                 onClick={() => setOpen(!open)}
//                 onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                         setOpen(!open);
//                     }
//                 }}
//             >
//                 <div className="parent-icon">
//                     {sidebarOpen && (
//                         <>
//                             <IoDocumentText size={16} className="me-2" />
//                             <span>{parent.service_name}</span>
//                         </>
//                     )}
//                 </div>

//                 {sidebarOpen && (
//                     <span className="parent-arrow">{open ? "▾" : "▸"}</span>
//                 )}
//             </div>

//             {open && (
//                 <div className="children-wrapper">
//                     {kids.map((child) => (
//                         <div
//                             key={child.service_id}
//                             role="button"
//                             tabIndex={0}
//                             className={`child-item ${activeMenu === child.target?.toLowerCase()
//                                 ? "active"
//                                 : ""
//                                 }`}
//                             onClick={() => onSelect(child)}
//                             onKeyDown={(e) => {
//                                 if (e.key === "Enter" || e.key === " ") {
//                                     onSelect(child);
//                                 }
//                             }}
//                         >
//                             <IoDocumentText size={16} className="me-2" />
//                             <span>{child.service_name}</span>
//                         </div>
//                     ))}
//                 </div>
//             )}
//         </li>
//     );
// }

// export function MenuItem({ item, kids, activeMenu, onSelect, sidebarOpen, defaultIcon }) {

//     const ItemIcon = defaultIcon || MdEditDocument;

//     if (kids && kids.length > 0) {
//         return (
//             <ParentSection
//                 parent={item}
//                 kids={kids}
//                 activeMenu={activeMenu}
//                 onSelect={onSelect}
//                 sidebarOpen={sidebarOpen}
//             />
//         );
//     }

//     return (
//         <li
//             className={`single-menu ${activeMenu === item?.target?.toLowerCase()
//                 ? "active"
//                 : ""
//                 }`}
//             role="menuitem"
//             tabIndex={0}
//             onClick={() => onSelect(item)}
//             onKeyDown={(e) => {
//                 if (e.key === "Enter" || e.key === " ") {
//                     onSelect(item);
//                 }
//             }}
//         >
//             <ItemIcon size={16} className="me-2" />
//             {sidebarOpen && <span>{item.service_name}</span>}
//         </li>
//     );
// }

// export const showValue = (value) => (value ? value : "-");

import React,
{
    useEffect,
    useState
}

    from "react";
import * as FaIcons from "react-icons/fa";
import * as MdIcons from "react-icons/md";
import * as IoIcons from "react-icons/io5";

/* ===========================================================
   INLINE COLOR PALETTE (edit here to retheme everything)
   =========================================================== */
const Icons = {
    ...FaIcons,
    ...MdIcons,
    ...IoIcons,
}

    ;

const COLORS = {
    parentBg: "#fff",
    parentBgActive: "#037224",
    parentBgHover: "#037224",
    pttextHover: "#fff",

    childBg: "#ffffff",
    childBgHover: "#037224",
    childBgActive: "#075c21",
    childText: "#042C53",
    childTextActive: "#042C53",

    singleBg: "#ffffff",
    singleBgHover: "#002e74",
    singleBgActive: "#0C447C",
    singleText: "#042C53",
    singleTextActive: "#ffffff",
    whiteFont: "#fff",
    ptBorder: "#979797",
    svgHover: "#fff",
    chcolorhover: "#fff",
    pthovercolor: "#fff",
    childBgtext: "#000",
}

    ;

const overrideCss = `
 .parent-title {
	background-color: ${COLORS.parentBg} !important;
	color: ${COLORS.parentText} !important;
	border-color: ${COLORS.ptBorder} !important;
}

.parent-title:hover {
	background-color: ${COLORS.parentBgHover} !important;
	color: ${COLORS.pthovercolor} !important;
}
.parent-title:hover span{
color: ${COLORS.pttextHover} !important;
}
.parent-title.parent-has-active {
	background-color: ${COLORS.parentBgActive} !important;
	color:${COLORS.parentBgActive} !important;
}

.parent-title span,
.parent-title svg {
	color: ${COLORS.parentText} !important;
	opacity: 1 !important;
}


.parent-title svg:hover {
	color: ${COLORS.svgHover} !important;
	opacity: 1 !important;
}

.parent-title hover: .parent-title span{
color: ${COLORS.pthovercolor} !important;
}

.child-item {
	background-color: transparent !important;
	opacity: 1 !important;
}

.child-item:hover {
	background-color: ${COLORS.childBgHover} !important;
}

.child-item.active {
	background-color: ${COLORS.childBgActive} !important;

}




.single-menu {
	opacity: 1 !important;
}

.single-menu:hover {
}

.single-menu.active {
	background-color: ${COLORS.singleBgActive} !important;
	
}

.single-menu span,
.single-menu svg {
	opacity: 1 !important;
}

`;

// export function ParentSection({ parent, kids, activeMenu, onSelect, sidebarOpen }) {
//     const [open, setOpen] = useState(false);
//     const [parentHover, setParentHover] = useState(false);
//     const [hoveredChildId, setHoveredChildId] = useState(null);

//     const hasActiveChild = kids.some(
//         (k) => k.target?.toLowerCase() === activeMenu
//     );

//     useEffect(() => {
//         if (hasActiveChild) setOpen(true);
//     }, [hasActiveChild]);

//     const parentStyle = {
//         backgroundColor: hasActiveChild
//             ? COLORS.parentBgActive
//             : parentHover
//                 ? COLORS.parentBgHover
//                 : COLORS.parentBg,
//         color: COLORS.parentText,
//         borderRadius: "8px",
//         margin: "4px 8px",
//         padding: "10px 12px",
//         cursor: "pointer",
//         transition: "background-color 0.2s ease",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "space-between",
//     };

//     return (
//         <li className="parent-menu">
//             <style>{overrideCss}</style>
//             <div
//                 className={`parent-title ${hasActiveChild ? "parent-has-active" : ""}`}
//                 role="button"
//                 tabIndex={0}
//                 style={parentStyle}
//                 onMouseEnter={() => setParentHover(true)}
//                 onMouseLeave={() => setParentHover(false)}
//                 onClick={() => setOpen(!open)}
//                 onKeyDown={(e) => {
//                     if (e.key === "Enter" || e.key === " ") {
//                         setOpen(!open);
//                     }
//                 }}
//             >
//                 <div className="parent-icon" style={{ display: "flex", alignItems: "center" }}>
//                     {sidebarOpen && (
//                         <>
//                             <IoDocumentText size={16} className="me-2" style={{ color: COLORS.parentText }} />
//                             <span style={{ fontWeight: 600 }}>{parent.service_name}</span>
//                         </>
//                     )}
//                 </div>
//                 {sidebarOpen && (
//                     <span className="parent-arrow" style={{ color: COLORS.parentText }}>
//                         {open ? "▾" : "▸"}
//                     </span>
//                 )}
//             </div>

//             {open && (
//                 <div
//                     className="children-wrapper"
//                     style={{
//                         backgroundColor: COLORS.childBg,
//                         borderRadius: "8px",
//                         margin: "2px 8px 6px 8px",
//                         overflow: "hidden",
//                     }}
//                 >
//                     {kids.map((child) => {
//                         const isActive = activeMenu === child.target?.toLowerCase();
//                         const isHovered = hoveredChildId === child.service_id;
//                         const childStyle = {
//                             backgroundColor: isActive
//                                 ? COLORS.childBgActive
//                                 : isHovered
//                                     ? COLORS.childBgHover
//                                     : "transparent",
//                             color: isActive ? COLORS.childTextActive : COLORS.childText,
//                             padding: "9px 14px 9px 24px",
//                             cursor: "pointer",
//                             display: "flex",
//                             alignItems: "center",
//                             fontSize: "0.9rem",
//                             fontWeight: isActive ? 600 : 400,
//                             borderLeft: isActive ? `3px solid ${COLORS.parentBg}` : "3px solid transparent",
//                             transition: "background-color 0.15s ease, color 0.15s ease",
//                         };
//                         return (
//                             <div
//                                 key={child.service_id}
//                                 role="button"
//                                 tabIndex={0}
//                                 className={`child-item ${isActive ? "active" : ""}`}
//                                 style={childStyle}
//                                 onMouseEnter={() => setHoveredChildId(child.service_id)}
//                                 onMouseLeave={() => setHoveredChildId(null)}
//                                 onClick={() => onSelect(child)}
//                                 onKeyDown={(e) => {
//                                     if (e.key === "Enter" || e.key === " ") {
//                                         onSelect(child);
//                                     }
//                                 }}
//                             >
//                                 <IoDocumentText
//                                     size={16}
//                                     className="me-2"
//                                     style={{ color: isActive ? COLORS.childTextActive : COLORS.childText }}
//                                 />
//                                 <span>{child.service_name}</span>
//                             </div>
//                         );
//                     })}
//                 </div>
//             )}
//         </li>
//     );
// }

// export function MenuItem({ item, kids, activeMenu, onSelect, sidebarOpen, defaultIcon }) {
//     const ItemIcon = defaultIcon || MdEditDocument;
//     const [hover, setHover] = useState(false);

//     if (kids && kids.length > 0) {
//         return (
//             <ParentSection
//                 parent={item}
//                 kids={kids}
//                 activeMenu={activeMenu}
//                 onSelect={onSelect}
//                 sidebarOpen={sidebarOpen}
//             />
//         );
//     }

//     const isActive = activeMenu === item?.target?.toLowerCase();
//     const singleStyle = {
//         backgroundColor: isActive
//             ? COLORS.singleBgActive
//             : hover
//                 ? COLORS.singleBgHover
//                 : COLORS.singleBg,
//         color: isActive ? COLORS.singleTextActive : COLORS.singleText,
//         borderRadius: "8px",
//         margin: "4px 8px",
//         padding: "10px 12px",
//         cursor: "pointer",
//         display: "flex",
//         alignItems: "center",
//         transition: "background-color 0.2s ease, color 0.2s ease",
//         boxShadow: isActive ? "none" : "0 1px 2px rgba(0,0,0,0.04)",
//     };

//     return (
//         <li
//             className={`single-menu ${isActive ? "active" : ""}`}
//             role="menuitem"
//             tabIndex={0}
//             style={singleStyle}
//             onMouseEnter={() => setHover(true)}
//             onMouseLeave={() => setHover(false)}
//             onClick={() => onSelect(item)}
//             onKeyDown={(e) => {
//                 if (e.key === "Enter" || e.key === " ") {
//                     onSelect(item);
//                 }
//             }}
//         >
//             <style>{overrideCss}</style>
//             <ItemIcon size={16} className="me-2" style={{ color: isActive ? COLORS.singleTextActive : COLORS.singleText }} />
//             {sidebarOpen && <span>{item.service_name}</span>}
//         </li>
//     );
// }
export function ParentSection({

    parent,
    kids,
    activeMenu,
    onSelect,
    sidebarOpen,
    openMenuId,
    setOpenMenuId,
}) {

    const open = openMenuId === parent.service_id;
    const [parentHover,
        setParentHover] = useState(false);
    const [hoveredChildId,
        setHoveredChildId] = useState(null);

    const ParentIcon = Icons[parent.icon] || IoIcons.IoDocumentText;
    const hasActiveChild = kids.some((k) => k.target?.toLowerCase() === activeMenu);

    useEffect(() => {
        if (hasActiveChild) {
            setOpenMenuId(parent.service_id);
        }
    }

        , [hasActiveChild, parent.service_id, setOpenMenuId]);

    const parentStyle = {
        backgroundColor: hasActiveChild ? COLORS.parentBgActive : parentHover ? COLORS.parentBgHover : COLORS.parentBg,
        borderRadius: "8px",
        margin: "4px 8px",
        padding: "10px 12px",
        cursor: "pointer",
        transition: "background-color 0.2s ease",
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
    }

        ;

    return (<li className="parent-menu" > <style> {
        overrideCss
    }

    </style> <div className={
        `parent-title ${hasActiveChild ? "parent-has-active" : ""}`
    }

        role="button"

        tabIndex={
            0
        }

        style={
            parentStyle
        }

        onMouseEnter={
            () => setParentHover(true)
        }

        onMouseLeave={
            () => setParentHover(false)
        }

        onClick={
            () => setOpenMenuId(openMenuId === parent.service_id ? null : parent.service_id)
        }

        onKeyDown={
            (e) => {
                if (e.key === "Enter" || e.key === " ") {
                    setOpenMenuId(openMenuId === parent.service_id ? null : parent.service_id);
                }
            }
        }

    > <div
        className="parent-icon"
        style={{ display: "flex", alignItems: "center" }}
    >
                <ParentIcon size={16} className="me-2" />

                {sidebarOpen && (
                    <span
                        className="parent-info"
                        style={{ fontWeight: 500 }}
                    >
                        {parent.service_name}
                    </span>
                )}
            </div> {
                sidebarOpen && (<span className="parent-arrow"



                > {
                        open ? "▾" : "▸"
                    }

                </span>)
            }

        </div> {
            open && (<div className="children-wrapper"

                style={
                    {
                        backgroundColor: COLORS.childBg,
                        borderRadius: "8px",
                        margin: "2px 8px 6px 8px",
                        overflow: "hidden",
                        color: "COLORS.childBgtext",
                    }
                }

            > {
                    kids.map((child) => {
                        const ChildIcon = Icons[child.icon] || IoIcons.IoDocumentText;

                        const isActive = activeMenu === child.target?.toLowerCase();

                        const isHovered = hoveredChildId === child.service_id;

                        const childStyle = {
                            backgroundColor: isActive ? COLORS.childBgActive : isHovered ? COLORS.childBgHover : "transparent",
                            color: isActive ? COLORS.childTextActive : COLORS.childText,
                            padding: "9px 14px 9px 24px",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "0.9rem",
                            fontWeight: isActive ? 600 : 400,
                            borderLeft: isActive ? `3px solid ${COLORS.parentBg}` : "3px solid transparent",
                            transition: "background-color 0.15s ease, color 0.15s ease",
                        }

                            ;

                        return (<div key={
                            child.service_id
                        }

                            role="button"

                            tabIndex={
                                0
                            }

                            className={
                                `child-item ${isActive ? "active" : ""

                                }

								`
                            }

                            style={
                                childStyle
                            }

                            onMouseEnter={
                                () => setHoveredChildId(child.service_id)
                            }

                            onMouseLeave={
                                () => setHoveredChildId(null)
                            }

                            onClick={
                                () => onSelect(child)
                            }

                            onKeyDown={
                                (e) => {
                                    if (e.key === "Enter" || e.key === " "

                                    ) {
                                        onSelect(child);
                                    }
                                }
                            }

                        > <ChildIcon size={
                            16
                        }
                            className=" inner-icon-color"

                            /> <span className="inner-items-span"> {
                                child.service_name
                            }

                            </span> </div>);
                    })
                }

            </div>)
        }

    </li>);
}

export function MenuItem({

    item,
    kids,
    activeMenu,
    onSelect,
    sidebarOpen,
    defaultIcon,
    openMenuId,
    setOpenMenuId,
}) {
    const ItemIcon = Icons[item.icon] || defaultIcon || MdIcons.MdEditDocument;

    const [hover,
        setHover] = useState(false);

    if (kids && kids.length > 0) {
        return (<ParentSection parent={
            item
        }

            kids={
                kids
            }

            activeMenu={
                activeMenu
            }

            onSelect={
                onSelect
            }

            sidebarOpen={
                sidebarOpen
            }

            openMenuId={
                openMenuId
            }

            setOpenMenuId={
                setOpenMenuId
            }

        />);
    }

    const isActive = activeMenu === item?.target?.toLowerCase();

    const singleStyle = {
        backgroundColor: isActive ? COLORS.singleBgActive : hover ? COLORS.singleBgHover : COLORS.singleBg,
        color: isActive ? COLORS.singleTextActive : COLORS.singleText,
        borderRadius: "8px",
        margin: "4px 8px",
        padding: "10px 12px",
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        transition: "background-color 0.2s ease, color 0.2s ease",
        boxShadow: isActive ? "none"
            : "0 1px 2px rgba(0,0,0,0.04)",
    }

        ;

    return (
        <li className=
            {
                `single-menu mx-0 ${isActive ? "active" : ""

                }

		`
            }


            role="menuitem"

            tabIndex={
                0
            }

            style={
                singleStyle
            }

            onMouseEnter={
                () => setHover(true)
            }

            onMouseLeave={
                () => setHover(false)
            }

            onClick={
                () => onSelect(item)
            }

            onKeyDown={
                (e) => {
                    if (e.key === "Enter" || e.key === " ") {
                        onSelect(item);
                    }
                }
            }

        > <style> {
            overrideCss
        }

            </style> <ItemIcon className="inner-icon-color" size={
                16
            }





            /> {
                sidebarOpen && (<span> {
                    item.service_name
                }

                </span>)
            }

        </li>);
}

export const showValue = (value) => (value ? value : "-");